import type { MealScaleData, ScaleSelectorProps } from "@qendo/profile/journal";
import { MealType, MealTypeMap, type ScaleType } from "@qendo/trackables";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RadioSelector } from "~/components/form/radio/RadioSelector";

export type MealSelectorProps = ScaleSelectorProps<ScaleType.meal>;

type MealValue = `${MealType}`;
type MealTypeOption = { value: MealValue; label: string };

function toMealValue(meal: MealType | null): MealValue | null {
    return meal === null ? null : `${meal}`;
}
function toMeal(meal: MealValue): MealType {
    return (
        (meal === toMealValue(MealType.breakfast) && MealType.breakfast) ||
        (meal === toMealValue(MealType.lunch) && MealType.lunch) ||
        (meal === toMealValue(MealType.dinner) && MealType.dinner) ||
        MealType.snack
    );
}

const MealOptions: MealTypeOption[] = Object.entries(MealTypeMap).map(
    ([value, label]) => ({ value, label }) as MealTypeOption,
);

export const MealSelector = ({ value, onUpdateScale, disabled, zIndex }: MealSelectorProps) => {
    const meal = toMealValue(value.value);

    const changeMeal = (m: MealValue) => {
        if (meal !== m) {
            onUpdateScale({ ...value, value: toMeal(m) } as MealScaleData);
        }
    };

    return (
        <FieldGroup zIndex={zIndex}>
            <RadioSelector<MealValue>
                title="What meal is this?"
                options={MealOptions}
                value={meal}
                onValueChange={changeMeal}
                columns={2}
                disabled={disabled}
            />
        </FieldGroup>
    );
};
